import { ROOM_TYPES_ARRAY } from "../constants/room-types";

export const getRoomTypeName = (roomTypeId) => {
  const roomType =
    ROOM_TYPES_ARRAY.find((roomType) => roomType.id === roomTypeId) || null;

  return roomType ? roomType.label : "";
};
